import ABCyaPhaser from "@abcya/abcya_phaser";
import gameData from "../gameData";

export default class Clock extends Phaser.GameObjects.Container
{
    constructor(scene, p, m, s)
    {
        super(scene);

        this.scene = scene;
        this.minutes = m;
        this.seconds = s;
        this.pCont = p;

        this.pCont.timeCont.add(this);
		
        this.createItem();
    };

    createItem()
    {
        if(this.minutes != null && this.seconds != null){
            this.timeTxt = this.convertNumber(this.minutes) + ":" + this.convertNumber(this.seconds);
        } if(this.seconds != null && this.minutes == null){
            this.timeTxt = this.convertNumber(this.seconds);
        }

        this.txt = ABCyaPhaser.Text.addText(0, 0, 25, "0xFFFFFF", gameData.GAME_FONTS[0], this.timeTxt, this);
    }

    countdown(){
        if(this.seconds <= 0){
            this.seconds = 0;

            if(this.minutes){
                if(this.minutes <= 0){
                    this.minutes = 0;
                } else {
                    this.seconds = 59;
                    this.minutes--;

                    //Do something when a minute ticks down
                    if(this.minutes != 2) this.pCont.callParentAbility("create");
                }
            } else {
                //console.log("GAME OVER");
                this.clockTween.destroy();
                gameData.GAME_DONE = true;

                this.pCont.callParentAbility("end");
            }
        } else {
            if(!gameData.GAME_PAUSED)
            {
                this.seconds--;
            }
        }

        //update the time variables
        if(this.minutes != null && this.seconds != null){
            this.timeTxt = this.convertNumber(this.minutes) + ":" + this.convertNumber(this.seconds);
        } if(this.seconds != null && this.minutes == null){
            this.timeTxt = this.convertNumber(this.seconds);
        }

        //set the text to the converted time numbers
        this.txt.text = this.timeTxt;

        //if the game hasn't ended, recall this function every second
        if(!gameData.GAME_DONE){
            this.clockTween = this.scene.time.delayedCall(1000, ()=>{this.countdown();});
        }
    };

    convertNumber(n){
        //add a 0 in front of a number if it's below 10
        let t;

        //if the input number is less than 10, convert it to a 2 digit number by adding a 0 before it.
        if(String(n).length < 2){
           t = "0" + String(n);
        } else {
            t = String(n);
        }

        return t;
    };
}